import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MoonIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const el = document.getElementById('hero-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-101" data-mp="bprejgy5e7mi">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2" data-id="element-102" data-mp="boyd8vhykabr">
          <a href={CHECKOUT_URL} className="pn-shake mx-auto flex max-w-md items-center justify-center gap-2 rounded-2xl bg-plum px-4 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-[0_10px_30px_-6px_rgba(59,26,94,0.7)] ring-2 ring-gold focus:outline-none focus-visible:ring-4" data-id="element-103" data-mp="2b4juxj6my2lj">
            <MoonIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-104" data-mp="1rdydsc0x2lzh" />
            Get it now for $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}